import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { serverUrl } from '../../../Constant/Static/config';
import DeleteIcon from '../../../Constant/Icons/delete.svg';
import editIcon from '../../../Constant/Icons/edit.svg';
import saveIcon from '../../../Constant/Icons/save.svg';
import cancelIcon from '../../../Constant/Icons/cancel.svg';
import addIcon from '../../../Constant/Icons/addItem.svg';

function HandleSchedule() {
    const [schedule, setSchedule] = useState([]);
    const [newEvent, setNewEvent] = useState('');
      const [newEventTamil, setNewEventTamil] = useState('');
    const [newStartDate, setNewStartDate] = useState('');
    const [newEndDate, setNewEndDate] = useState('');
    const [editId, setEditId] = useState(null);
    const [editEvent, setEditEvent] = useState('');
    const [editEventTamil, setEditEventTamil] = useState('');
    const [editStartDate, setEditStartDate] = useState('');
    const [editEndDate, setEditEndDate] = useState('');

    const fetchSchedule = async () => {
        try {
            const response = await axios.get(`${serverUrl}/api/admin/services/schedule`);
            setSchedule(response.data);
        } catch (error) {
            console.error('Error fetching schedule:', error);
        }
    };

    const handleAddEvent = async () => {
        try {
            const response = await axios.post(`${serverUrl}/api/admin/services/schedule`, {
                event: newEvent,
                eventTamil:newEventTamil,
                startDate: newStartDate,
                endDate: newEndDate
            });
            setSchedule([...schedule, response.data]);
            setNewEvent('');
            setNewStartDate('');
            setNewEventTamil('');
            setNewEndDate('');
        } catch (error) {
            console.error('Error adding event:', error);
        }
    };

    const handleEditEvent = (id, event,eventTamil, startDate, endDate) => {
        setEditId(id);
        setEditEvent(event);
        setEditEventTamil(eventTamil)
        setEditStartDate(startDate);
        setEditEndDate(endDate);
    };

    const handleUpdateEvent = async () => {
        try {
            const response = await axios.put(`${serverUrl}/api/admin/services/schedule/${editId}`, {
                event: editEvent,
                startDate: editStartDate,
                eventTamil:editEventTamil,
                endDate: editEndDate
            });
            setSchedule(schedule.map(item => (item.id === editId ? response.data : item)));
            setEditId(null);
            setEditEvent('');
            setEditEventTamil('')
            setEditStartDate('');
            setEditEndDate('');
        } catch (error) {
            console.error('Error updating event:', error);
        }
    };

    const handleDeleteEvent = async (id) => {
        try {
            await axios.delete(`${serverUrl}/api/admin/services/schedule/${id}`);
            setSchedule(schedule.filter(item => item.id !== id));
        } catch (error) {
            console.error('Error deleting event:', error);
        }
    };

    useEffect(() => {
        fetchSchedule();
    }, []);

    return (
        <div className="chat-bot-container">
            <div className="chat-bot-header">Counseling Schedule Bot</div>
            <div className="chat-bot-messages">
                {schedule.map(item => (
                    <div key={item.id} className="chat-bot-message">
                        {editId === item.id ? (
                            <>
                                <input
                                    type="text"
                                    value={editEvent}
                                    onChange={(e) => setEditEvent(e.target.value)}
                                    className="edit-input"
                                    placeholder="Event Name"
                                />
                                 <input
                                    type="text"
                                    value={editEventTamil}
                                    onChange={(e) => setEditEventTamil(e.target.value)}
                                    className="edit-input"
                                    placeholder="Event Name in Tamil"
                                />
                                <input
                                    type="date"
                                    value={editStartDate}
                                    onChange={(e) => setEditStartDate(e.target.value)}
                                    className="edit-input"
                                    placeholder="Start Date"
                                />
                                <input
                                    type="date"
                                    value={editEndDate}
                                    onChange={(e) => setEditEndDate(e.target.value)}
                                    className="edit-input"
                                    placeholder="End Date"
                                />
                                <div className="action-buttons">
                                    <button className="btn" onClick={handleUpdateEvent}>
                                        <img src={saveIcon} alt='save' width={20} height={20} />
                                    </button>
                                    <button className="btn" onClick={() => setEditId(null)}>
                                        <img src={cancelIcon} alt='cancel' width={20} height={20} />
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <span>{item.event} -{item.eventTamil} {item.startDate} to {item.endDate}</span>
                                <div className="action-buttons">
                                    <button className="btn" onClick={() => handleEditEvent(item.id, item.event,item.eventTamil, item.startDate, item.endDate)}>
                                        <img src={editIcon} alt='edit' width={20} height={20} />
                                    </button>
                                    <button className="btn" onClick={() => handleDeleteEvent(item.id)}>
                                        <img src={DeleteIcon} alt='delete' width={20} height={20} />
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
            <div className="chat-bot-input">
                <input
                    type="text"
                    value={newEvent}
                    onChange={(e) => setNewEvent(e.target.value)}
                    placeholder="New Event Name in English"
                    className="add-input"
                />
                  <input
                    type="text"
                    value={newEventTamil}
                    onChange={(e) => setNewEventTamil(e.target.value)}
                    placeholder="New Event Name in Tamil"
                    className="add-input"
                />
                <input
                    type="date"
                    value={newStartDate}
                    onChange={(e) => setNewStartDate(e.target.value)}
                    className="add-input"
                    placeholder="Start Date"
                />
                <input
                    type="date"
                    value={newEndDate}
                    onChange={(e) => setNewEndDate(e.target.value)}
                    className="add-input"
                    placeholder="End Date"
                />
                <button onClick={handleAddEvent} className="btn">
                    <img src={addIcon} alt='add' width={20} height={20} />
                </button>
            </div>
        </div>
    );
};

export default HandleSchedule;